import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation JoinChat($id: ID!, $chatControlToken: String) {
    joinChat(id: $id, chatControlToken: $chatControlToken) {
      id
    }
  }
`);
